import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";
import Loader from "../components/Loader"; 
import ImageUpload from '../components/ImageUpload';

const Setting = () => {
  const navigate = useNavigate();
  const admin= JSON.parse(localStorage.getItem('admin'));
  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({
    payment_mode: 'test',
    ios_version: '',
    android_version: '',
    booking_fee_percentage: 0,
    max_booking_cap: 0,
    bottom_banner: '',
    banner_title: '',
    banner_description: '',
    banner_image: '',
    account_title: '',
    account_description: '',
    account_image: '',
    vat: '',
    club_summary: '',
  });
  const [clubSummaryFile, setClubSummaryFile] = useState(null);
  const [clubSummaryUrl, setClubSummaryUrl] = useState(null);


useEffect(() => {
    getSingleData();
}, []);


const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoader(true);
    try {
        const form_data = new FormData();
        Object.keys(formData).forEach((key) => {
            if (key !== 'bottom_banner' && key !== 'banner_image' && key !== 'club_summary') {
                form_data.append(key, formData[key]);
            }
        });

        // Handle file uploads
        if (formData.bottom_banner && typeof formData.bottom_banner === 'object') {
            form_data.append('bottom_banner', formData.bottom_banner);
        }
        if (formData.banner_image && typeof formData.banner_image === 'object') {
            form_data.append('banner_image', formData.banner_image);
        }
        if (clubSummaryFile) {
            form_data.append('club_summary', clubSummaryFile);
        }

        const response = await ApiService.request({
            method: "POST",
            url: "admin/settings", 
            data: form_data,
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        const data = response.data;
        if (data.status) {
            toast.success(data.message);
            getSingleData(); // Refresh data
            setClubSummaryFile(null); // Clear file input after successful upload
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        console.log(error);
        setIsLoader(false);
    }
   
};

const getSingleData = async () => {
    setIsLoader(true);
    try {
        const response = await ApiService.request({
            method: 'GET',
            url: `admin/settings`,
        });
        const data = response.data;
        if (data.status) {
            setFormData(data.data);
            if (data.data.club_summary) {
                setClubSummaryUrl(data.data.club_summary);
            }
        } else {
            toast.error(data.message);
        }
    } catch (error) {
        console.error(error);
        toast.error('Failed to load settings');
    } finally {
        setIsLoader(false);
    }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFileChange = (name, file) => {
    if (name === 'club_summary') {
      setClubSummaryFile(file);
      if (file) {
        setClubSummaryUrl(URL.createObjectURL(file));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: file,
      }));
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid bg-secondary-dark">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        Setting
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="/TimeLogger/admin/" className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Setting</li>
                    </ul>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
            </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="card">
                   
                    <div className="card-body pt-0">
                        <div className="mb-8 text-center"></div>
                        <div className="row g-9 mb-8">
                        <div className="col-md-12">
                            <div className="tab-content mt-5" id="nav-tabContent">
                                <div className="tab-pane fade show active">
                                    <form className="form" onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Payment Mode</span>
                                                </label>
                                                <select name="payment_mode" value={formData.payment_mode} onChange={handleChange} className="form-select">
                                                    <option value="test">Test</option>
                                                    <option value="live">Live</option>
                                                </select>
                                            </div>
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Android Verions</span>
                                                </label>
                                                <input 
                                                    type="text" 
                                                    name="android_version" 
                                                    value={formData.android_version} 
                                                    onChange={handleChange} 
                                                    className="form-control" 
                                                    placeholder="Enter Android Version"
                                                    
                                                />
                                            </div>
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">IOS Verions</span>
                                                </label>
                                                <input 
                                                    type="text" 
                                                    name="ios_version" 
                                                    value={formData.ios_version} 
                                                    onChange={handleChange} 
                                                    className="form-control" 
                                                    placeholder="Enter IOS Version"
                                                />
                                            </div>
                                           
                                            
                                            {/* <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">Vat (%)</span>
                                                </label>
                                                <input 
                                                    type="number" 
                                                    name="vat" 
                                                    value={formData.vat} 
                                                    onChange={handleChange} 
                                                    className="form-control" 
                                                    placeholder="Enter booking vat percentage"
                                                    min="0"
                                                    step="1"
                                                />
                                            </div> */}
                                            <div className="col-md-4 my-3">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    Club Summary (PDF)
                                                </label>
                                                <input 
                                                    type="file" 
                                                    accept=".pdf"
                                                    onChange={(e) => handleFileChange('club_summary', e.target.files[0])}
                                                    className="form-control" 
                                                />
                                                {clubSummaryUrl && (
                                                    <div className="mt-3">
                                                        <div className="d-flex align-items-center gap-3">
                                                            <a 
                                                                href={clubSummaryUrl} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                className="btn btn-sm btn-light-primary"
                                                            >
                                                                <i className="fas fa-file-pdf me-2"></i>
                                                                {clubSummaryFile ? 'Preview New File' : 'View Current PDF'}
                                                            </a>
                                                            {clubSummaryFile && (
                                                                <span className="text-muted">
                                                                    New file selected: {clubSummaryFile.name}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                           
                                        </div>



                                        <OverlayTrigger placement="top" overlay={<Tooltip>Update Settings</Tooltip>}>
                                            <button
                                                type="submit"
                                                className="btn btn-base my-5"
                                                disabled={isLoader}
                                                >
                                                <span className="indicator-label">
                                                    {!isLoader ? "Update Settings" : <Loader size="20" text="Updating" />}
                                                </span>
                                            </button>
                                        </OverlayTrigger>
                                    </form>
                                </div>
                           
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  );
};

export default Setting;
